// Libraries
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { components } from 'react-select';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

// Components

// Actions
import {
    addCommProfileRequest,
    addCommProfileError,
} from '../../containers/CommProfile/redux/commProfile.actions';

// Constant
import { SUCCESS_MESSAGES } from '../../utils/constants/toastMessages';

// Validator
import { FormElems, CustomSelect, Alert } from '..';
import validate from './validator';

// Styles
import './addComm.scss';
import { isArray } from 'lodash';

const allOption = [{ value: 'all', label: 'All Merchants', checked: false }];

/**
 * Add Franchise Component
 *
 * @param {Object} props - React component props
 *
 */

const ValueContainer = ({ children, ...props }) => {
    const { getValue, hasValue } = props;
    const newChildren = [...children];
    const nbValues = getValue().filter(item => item.value !== 'all').length;
    newChildren[0] = `${nbValues} Merchants Selected`;

    if (!hasValue) {
        return (
            <components.ValueContainer {...props}>
                {children}
            </components.ValueContainer>
        );
    }
    return (
        <components.ValueContainer {...props}>
            {newChildren}
        </components.ValueContainer>
    );
};

const Option = props => {
    const { data, isSelected } = props;
    data.checked = isSelected;
    const dataOptions = [data];
    return (
        <components.Option {...props}>
            <div className={data.value}>
                <FormElems.Checkbox
                    name={data.value}
                    options={dataOptions || []}
                    valueField="value"
                    labelField="label"
                />
            </div>
        </components.Option>
    );
};

const renderCustomSelect = props => {
    const { input, data, ...attributes } = props;
    const handleBlur = () => input.onBlur;
    return (
        <div>
            <CustomSelect
                instanceId={input.name}
                {...input}
                {...attributes}
                value={data}
                onBlur={handleBlur}
            />
        </div>
    );
};

const formatGroupLabel = data => (
    <div className={`group-label ${data.label ? data.label : 'empty'}`}>
        <label>{data.label}</label>
    </div>
);

const AddComm = props => {
    const {
        closePopup,
        handleSubmit,
        actions,
        commData,
        staticData,
        selectedTab,
    } = props;

    const { notificationEvents, addCommProfile } = commData;
    const { underlyingMerchant } = staticData;

    const [selectedMerchant, setSelectedMerchant] = useState([]);
    const [merchantOptions, setMerchantOptions] = useState([]);
    const [eventOptions, setEventOptions] = useState([]);

    useEffect(() => {
        if (addCommProfile.isSuccess) {
            toast.info(SUCCESS_MESSAGES.ADD_DATA(`${selectedTab} Profile`));
            closePopup(true);
        }
        return () => {
            actions.addCommProfileError({ error: {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addCommProfile.isSuccess]);

    useEffect(() => {
        const formatEvents =
            notificationEvents && notificationEvents.eventList
            && isArray(notificationEvents.eventList)
            && notificationEvents.eventList.map(item => {
                return {
                    label: item,
                    value: item,
                };
            });
        setEventOptions(formatEvents || []);
    }, [notificationEvents]);

    useEffect(() => {
        const formatMerchant = underlyingMerchant.map(item => {
            return {
                label: item.name,
                value: item.entityCode,
                checked: false,
            };
        });
        const groupedOptions = [
            {
                label: '',
                options: allOption,
            },
            {
                label: 'Select Merchant',
                options: formatMerchant,
            },
        ];
        setMerchantOptions(groupedOptions);
    }, [underlyingMerchant]);

    const onCancel = (onSuccess, entityType) => {
        closePopup(onSuccess, entityType);
    };

    /**
     * Method to handle form submit values for Add Comm Profile
     * @param {object} values
     * @returns {null}
     */
    const handleFormSubmit = values => {
        const request = {
            entityCodes:
                selectedMerchant &&
                selectedMerchant
                    .filter(item => item.value !== 'all')
                    .map(item => item.value),
            profile: {
                comments: '',
                eventsList: values.eventsList,
                identifier: values.identifier,
                status: true,
                type: selectedTab,
                version: values.version
            },
        };
        actions.addCommProfileRequest(request);
    };

    const getAllSelectedMerchant = allMerchantList => {
        const merchantList = allMerchantList[1];
        if (merchantList) {
            return [...allOption, ...merchantList.options];
        }
        return [];
    };

    const checkIsAllRemoved = (oldState, newState) => {
        const isOldStateHaveAll = oldState.some(item => item.value === 'all');
        const isNewStateHaveAll = newState.some(item => item.value === 'all');
        return isOldStateHaveAll !== isNewStateHaveAll;
    };

    const isAllClicked = (oldState, newState) => {
        const isOldStateHaveAll = oldState.some(item => item.value === 'all');
        const isNewStateHaveAll = newState.some(item => item.value === 'all');
        return isOldStateHaveAll === false && isNewStateHaveAll === true;
    };

    const handleMerchantSelect = value => {
        const isAllRemoved = checkIsAllRemoved(selectedMerchant, value);

        if (isAllClicked(selectedMerchant, value)) {
            const allMerchants = getAllSelectedMerchant(merchantOptions);
            setSelectedMerchant(allMerchants);
        } else if (isAllRemoved) {
            setSelectedMerchant([]);
        } else {
            const selectedValue = value.filter(item => item.value !== 'all');
            if (selectedValue.length === merchantOptions[1].options.length) {
                setSelectedMerchant([...allOption, ...value]);
            } else {
                setSelectedMerchant(selectedValue);
            }
        }
    };
    return (
        <form className="add-comm-form">
            {addCommProfile.error && addCommProfile.error.errorMessage ? (
                <Alert customClass="error-msg">
                    {addCommProfile.error.errorMessage}
                </Alert>
            ) : null}
            {selectedTab === 'EMAIL' ? (
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Email</p>
                        <Field
                            name="identifier"
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter Email"
                        />
                    </div>
                </div>
            ) : null}
            {selectedTab === 'SMS' ? (
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">Mobile Number</p>
                        <Field
                            name="identifier"
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter Mobile"
                        />
                    </div>
                </div>
            ) : null}
            {selectedTab === 'WEBHOOK' ? (
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">URL</p>
                        <Field
                            name="identifier"
                            type="text"
                            component={FormElems.Input}
                            placeholder="Enter URL"
                        />
                    </div>
                </div>
            ) : null}
            <div className="form-section">
                <div className="form-field">
                    <p className="label">Merchant Name</p>
                    <Field
                        name="entityCodes"
                        customClass="wrapper-select"
                        options={merchantOptions}
                        components={{ Option, ValueContainer }}
                        isMulti
                        isSearchable
                        data={selectedMerchant}
                        onChange={handleMerchantSelect}
                        closeMenuOnSelect={false}
                        component={renderCustomSelect}
                        placeholder="Select Merchant"
                        formatGroupLabel={formatGroupLabel}
                    />
                </div>
            </div>
            {selectedTab === 'WEBHOOK' ? (
                <div className="form-section">
                    <div className="form-field">
                        <p className="label">VERSION</p>
                        <Field
                            name="version"
                            placeholder="Select Version"
                            id="version"
                            data={
                                [
                                    {
                                        name: '1.0',
                                        value: '1.0',
                                    },
                                    {
                                        name: '2.0',
                                        value: '2.0',
                                    },
                                    {
                                        name: '3.0',
                                        value: '3.0',
                                    },
                                     {
                                        name: '4.0',
                                        value: '4.0',
                                    },
                                     {
                                        name: '5.0',
                                        value: '5.0',
                                    },
                                ]
                            }
                            labelField="name"
                            valueField="value"
                            component={FormElems.Select}
                            label="Select Version"
                        />
                    </div>
                </div>
            ) : null}
            <div className="form-section">
                <p className="label">Select Event</p>
                <div className="form-field checkbox-wrap">
                    <Field
                        customClass="eventCheckBox"
                        name="eventsList"
                        options={eventOptions}
                        valueField="value"
                        labelField="label"
                        component={FormElems.Checkbox}
                    />
                </div>
            </div>
            <div className="form-section action">
                <FormElems.Button
                    buttonType="secondary"
                    text="CANCEL"
                    handleClick={onCancel}
                />
                <FormElems.Button
                    buttonType="primary"
                    text="SUBMIT"
                    handleClick={handleSubmit(handleFormSubmit)}
                />
            </div>
        </form>
    );
};

Option.propTypes = {
    data: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
};

ValueContainer.propTypes = {
    hasValue: PropTypes.bool,
    children: PropTypes.array,
    getValue: PropTypes.func,
};

const mapStateToProps = ({ auth, form, commData, staticData }) => ({
    auth,
    form,
    commData,
    staticData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        { addCommProfileRequest, addCommProfileError },
        dispatch
    ),
});

AddComm.propTypes = {
    actions: PropTypes.object,
    actionType: PropTypes.string,
    selectedTab: PropTypes.string,
    closePopup: PropTypes.func,
    commData: PropTypes.object,
    staticData: PropTypes.object,
    form: PropTypes.object,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
};

export default compose(
    reduxForm({
        form: 'add-mail',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(AddComm);
